var _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAchievementBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.49,313.69c-14.22,38.09-43.27,79.31-84.16,91.52-61.78,18.44-69.16,68.24-179.81,63.62a223.56,223.56,0,0,1-47.85-7,184.85,184.85,0,0,1-22.5-7.49C61.53,428.15,27.81,370.52,25,310.23c-3.69-79.3,51.64-117.1,87.6-139.23S191.91,63.11,300.72,66.79A216.38,216.38,0,0,1,349.91,74c36.61,9.91,73.83,31.82,95.46,63.87,1.62,2.4,3.17,4.87,4.65,7.38C479,194.33,479.88,261.77,460.49,313.69Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.49,313.69c-14.22,38.09-43.27,79.31-84.16,91.52-61.78,18.44-69.16,68.24-179.81,63.62a223.56,223.56,0,0,1-47.85-7,184.85,184.85,0,0,1-22.5-7.49C61.53,428.15,27.81,370.52,25,310.23c-3.69-79.3,51.64-117.1,87.6-139.23S191.91,63.11,300.72,66.79A216.38,216.38,0,0,1,349.91,74c36.61,9.91,73.83,31.82,95.46,63.87,1.62,2.4,3.17,4.87,4.65,7.38C479,194.33,479.88,261.77,460.49,313.69Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Target--inject-32"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119.44,
    cy: 112.17,
    r: 33.08,
    transform: "translate(-44.34 117.31) rotate(-45)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 119.44,
    cy: 112.17,
    r: 21.63,
    transform: "translate(-43.9 125.14) rotate(-47.74)",
    style: {
      fill: "#fff"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.44,
    cy: 112.17,
    r: 11.45
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M106.3,118.72l-.9,6.94,12.9-12.88-18.23.16,5.58,4.22L73.55,130.6l-9-1.57-8.54,3.58,5.62,3.16a.82.82,0,0,0,.51,1.21l-1.69,6.24L69,139.64l5-7.43Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.26,34.76V30.09h-4.5v4.67H410.71V30.09h-4.5v4.67h-13V30.09h-4.51v4.67h-13V30.09h-4.5v4.67H358.05V30.09h-4.5v4.67H337.34V130H441.1V34.76ZM353.73,123h-9.19v-9.18h9.19Zm0-13h-9.19v-9.19h9.19Zm0-13h-9.19V87.7h9.19Zm0-13.06h-9.19V74.65h9.19ZM367.13,123h-9.19v-9.18h9.19Zm0-13h-9.19v-9.19h9.19Zm0-13h-9.19V87.7h9.19Zm0-13.06h-9.19V74.65h9.19ZM380.53,123h-9.19v-9.18h9.19Zm0-13h-9.19v-9.19h9.19Zm0-13h-9.19V87.7h9.19Zm0-13.06h-9.19V74.65h9.19ZM393.92,123h-9.18v-9.18h9.18Zm0-13h-9.18v-9.19h9.18Zm0-13h-9.18V87.7h9.18Zm0-13.06h-9.18V74.65h9.18ZM407.32,123h-9.19v-9.18h9.19Zm0-13h-9.19v-9.19h9.19Zm0-13h-9.19V87.7h9.19Zm0-13.06h-9.19V74.65h9.19ZM420.72,123h-9.19v-9.18h9.19Zm0-13h-9.19v-9.19h9.19Zm0-13h-9.19V87.7h9.19Zm0-13.06h-9.19V74.65h9.19ZM434.12,123h-9.19v-9.18h9.19Zm0-13h-9.19v-9.19h9.19Zm0-13h-9.19V87.7h9.19Zm0-13.06h-9.19V74.65h9.19Zm.9-19.54H343.64V42.69H435Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.39,160.23s1.51-15.1-4.53-21.9-15.1,1.51-12.84,10.57S369.39,160.23,369.39,160.23Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,227.5S354.39,204,345,193.38s-23.53,2.36-20,16.48S352,227.5,352,227.5Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.94,265.64s-2.58-23.51-14-31.91-22.53,7.19-16.14,20.27S346.94,265.64,346.94,265.64Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.9,285.32C357,288,344.54,308.11,344.54,308.11s20.82,11.51,32.21,2.46S384.81,282.65,370.9,285.32Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.5,320.75c-19.9,3.83-37.71,32.6-37.71,32.6s29.79,16.47,46.09,3.51S395.4,316.92,375.5,320.75Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,308.43c.63,0,1,0,1,0s-.13-1.12-.44-3c1.59-8.91,3.2-20.12,5.11-33.52l.8-5.58c5.42,2.57,21,8.87,30.27,1.48,11.39-9.06,8.06-27.92-5.85-25.24-10.06,1.93-19.36,13-23.73,18.95,1.23-8.5,2.57-17.64,4.08-27.21.26-1.62.55-3.3.87-5.05,5.35,4,18.44,12.22,28.56,7.18,13-6.49,13.68-25.64-.48-25.91-10.2-.19-21.54,8.61-27.08,13.55,2-10.08,4.87-21.72,7.88-33.22,3.25,2.44,11.91,8.11,18.57,4.79,8.36-4.17,8.78-16.45-.31-16.62-6.61-.13-13.94,5.62-17.46,8.78,2.42-9.16,4.92-18.11,7.19-26,3.74,2.65,11.58,7.22,17.71,4.16,8.35-4.17,8.78-16.45-.31-16.62-5.78-.11-12.11,4.26-16,7.48,3.32-11.47,5.92-19.93,6.59-22.12,3.38-2.24,13.58-9.24,15.28-13.43A9.85,9.85,0,1,0,377,113.86c-1.63,4,.55,15.35,1.49,19.76l-.6-.19c-.09.27-3.48,11.23-7.85,26.42l-.27.27.15.13c-2.35,8.2-5,17.61-7.53,27.22.14-4.56-.13-14.34-4.67-19.44-6-6.8-15.1,1.51-12.83,10.57,2,8.1,14.3,10.76,16.88,11.24-3.39,12.93-6.57,26.07-8.66,37l-.47.48.33.28c-.42,2.2-.79,4.32-1.1,6.32-2.15,13.62-4,26.38-5.58,37.64-1.51,10.55-2.82,19.74-4.09,27.51-1.88-7.53-5.53-17.67-12.23-22.6-11.41-8.41-22.53,7.19-16.14,20.27,4.89,10,19.93,11.51,26.73,11.66-.26,1.34-.51,2.62-.77,3.84-1,4.85-2.66,18.21-4.27,32.87-2.24-10.8-7.5-28.87-18.57-37-16.32-12-32.23,10.29-23.09,29,7.67,15.71,32.85,16.78,40.73,16.72-2.16,20.47-4.08,40.78-4.23,42.34l2.36.22c.07-.71,6.75-71.29,9.39-83.62C342.41,311.39,342.7,310,343,308.43Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.86,233.39s-.88-8.79,2.64-12.74,8.79.88,7.47,6.15S163.86,233.39,163.86,233.39Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,272.56s-1.37-13.7,4.11-19.86,13.7,1.37,11.64,9.59S174,272.56,174,272.56Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.93,294.76s1.5-13.68,8.14-18.58,13.12,4.19,9.4,11.8S176.93,294.76,176.93,294.76Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,306.22c8.1,1.56,15.35,13.27,15.35,13.27s-12.13,6.7-18.76,1.43S154.88,304.66,163,306.22Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.3,326.85c11.59,2.23,22,19,22,19s-17.35,9.59-26.84,2.05S148.71,324.62,160.3,326.85Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.23,319.67c-.37,0-.58,0-.58,0s.08-.65.26-1.72c-.93-5.19-1.86-11.72-3-19.52-.15-1.05-.3-2.14-.46-3.25-3.16,1.5-12.22,5.17-17.63.86-6.63-5.27-4.69-16.25,3.41-14.69,5.86,1.13,11.27,7.56,13.82,11-.72-5-1.5-10.28-2.38-15.85q-.23-1.41-.51-2.94c-3.11,2.3-10.73,7.12-16.62,4.18-7.59-3.78-8-14.92.28-15.08,5.94-.11,12.53,5,15.76,7.89-1.18-5.87-2.83-12.65-4.58-19.35-1.9,1.43-6.94,4.73-10.82,2.8-4.86-2.43-5.11-9.58.18-9.68,3.85-.08,8.12,3.27,10.17,5.11-1.41-5.33-2.87-10.54-4.19-15.14-2.18,1.54-6.74,4.2-10.31,2.42-4.86-2.43-5.11-9.58.18-9.68,3.36-.06,7.05,2.49,9.3,4.36-1.94-6.68-3.45-11.6-3.84-12.88-2-1.3-7.91-5.38-8.9-7.82a5.74,5.74,0,0,1,10.63-4.31c1,2.34-.32,8.94-.87,11.5l.36-.11c0,.16,2,6.54,4.56,15.38l.16.16-.09.08c1.37,4.77,2.91,10.25,4.39,15.84-.09-2.65.08-8.35,2.72-11.32,3.51-4,8.79.88,7.47,6.16-1.18,4.71-8.33,6.26-9.83,6.54,2,7.53,3.82,15.18,5,21.56a3.37,3.37,0,0,1,.27.28l-.19.16c.24,1.28.46,2.51.64,3.67,1.26,7.94,2.32,15.36,3.25,21.92.88,6.14,1.64,11.49,2.38,16,1.09-4.39,3.22-10.29,7.12-13.16,6.64-4.9,13.12,4.18,9.4,11.8-2.85,5.82-11.61,6.7-15.56,6.79.15.78.3,1.53.45,2.23.6,2.83,1.54,10.6,2.48,19.14,1.3-6.28,4.37-16.81,10.81-21.56,9.5-7,18.76,6,13.44,16.89-4.46,9.14-19.12,9.76-23.71,9.73,1.26,11.92,2.38,23.74,2.47,24.65l-1.38.13c0-.42-3.93-41.51-5.46-48.69Q179.49,321,179.23,319.67Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9,341.77s-2.31-5.09-1-8.18,5.45-1.25,5.73,2.18S55.9,341.77,55.9,341.77Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.89,363.23s-3.59-7.94-1.56-12.75,8.5-2,8.93,3.39S69.89,363.23,69.89,363.23Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.17,376s-1.87-8.52,1.13-12.8,8.72-.14,8,5.18S76.17,376,76.17,376Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.13,385.65C75.3,385,82,390.5,82,390.5s-5.91,6.48-11,4.66S65,386.36,70.13,385.65Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7,398.57c7.4-1,17,6.94,17,6.94s-8.46,9.27-15.68,6.67S65.29,399.58,72.7,398.57Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6,390.43l-.35.11s-.09-.41-.2-1.09c-1.6-2.92-3.49-6.65-5.73-11.11-.31-.6-.62-1.22-.94-1.85-1.59,1.54-6.29,5.57-10.4,4.09-5.05-1.83-6.11-8.81-.94-9.51,3.75-.51,8.3,2.25,10.53,3.82-1.43-2.83-3-5.86-4.64-9-.28-.53-.58-1.08-.9-1.66-1.4,2-5,6.45-9.13,5.88-5.31-.73-7.8-7.34-2.88-9.11,3.54-1.27,8.54.47,11.06,1.54-1.9-3.28-4.27-7-6.68-10.68-.84,1.24-3.2,4.24-5.92,3.87-3.41-.47-5-4.71-1.85-5.84,2.29-.83,5.53.32,7.13,1-1.92-2.91-3.85-5.74-5.58-8.23-1,1.36-3.19,3.88-5.69,3.54-3.41-.47-5-4.71-1.85-5.84,2-.72,4.73.06,6.45.73-2.51-3.62-4.41-6.27-4.91-6.95-1.44-.39-5.83-1.63-6.92-2.89a3.64,3.64,0,1,1,5.51-4.75c1,1.22,1.62,5.43,1.81,7.08l.18-.13c.07.08,2.54,3.51,5.86,8.3l.13.06a.28.28,0,0,1,0,.07c1.79,2.58,3.82,5.56,5.84,8.62-.59-1.58-1.64-5-.66-7.35,1.31-3.08,5.45-1.25,5.73,2.18.25,3.07-3.73,5.45-4.57,5.92,2.71,4.12,5.37,8.34,7.39,11.91l.22.12-.08.13c.4.72.78,1.42,1.13,2.08,2.36,4.5,4.5,8.75,6.39,12.49,1.77,3.51,3.31,6.56,4.67,9.13-.23-2.85-.15-6.83,1.61-9.34,3-4.28,8.72-.14,8,5.18-.53,4.07-5.61,6.37-8,7.23.25.43.49.85.73,1.24.93,1.58,3.07,6.05,5.36,11-.49-4-.78-11,2.12-15.13,4.29-6.12,12.48-.21,11.49,7.41-.83,6.39-9.5,9.73-12.26,10.64,3.17,6.9,6.24,13.77,6.48,14.29l-.8.36c-.11-.24-10.77-24.11-13.15-28.11Q83,391.18,82.6,390.43Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.23,369.34s3.7-4.19,7-4.26,3.38,4.46.36,6.12S446.23,369.34,446.23,369.34Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.39,390.9s5.77-6.53,11-6.65,5.27,7,.56,9.54S432.39,390.9,432.39,390.9Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.36,401.84s7-5.19,12.13-4.22,3.71,7.9-1.43,9.45S423.36,401.84,423.36,401.84Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,400.3c2.76,4.43.45,12.84.45,12.84s-8.34-2.74-8.74-8.09S409.26,395.87,412,400.3Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.3,407.94c3.95,6.34.64,18.37.64,18.37s-11.92-3.93-12.51-11.58S397.34,401.6,401.3,407.94Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.78,413.64l-.24-.28.91-.62c2-2.67,4.64-5.91,7.78-9.79l1.31-1.61c-2.06-.82-7.66-3.45-8-7.82-.41-5.35,5.53-9.17,8.29-4.74,2,3.2,1.34,8.49.83,11.17,2-2.47,4.12-5.12,6.33-7.93.37-.48.76-1,1.15-1.5-2.41-.46-7.93-1.92-9.1-5.92-1.51-5.15,3.5-10.13,7.12-6.37,2.61,2.71,3.07,8,3.13,10.72,2.21-3.08,4.65-6.76,7-10.46-1.47-.27-5.18-1.19-5.95-3.82-1-3.3,2.25-6.5,4.57-4.09,1.69,1.76,2,5.19,2,6.93,1.86-2.95,3.66-5.88,5.23-8.47-1.66-.35-4.86-1.32-5.57-3.74-1-3.31,2.25-6.5,4.57-4.09,1.48,1.54,1.88,4.35,2,6.19,2.27-3.77,3.9-6.59,4.33-7.32-.24-1.48-.91-6-.2-7.5a3.63,3.63,0,1,1,6.58,3.08c-.68,1.45-4.29,3.7-5.72,4.55l.21.11c-.06.09-2.17,3.76-5.18,8.75v.14h-.08c-1.62,2.7-3.51,5.77-5.47,8.86,1.2-1.18,3.91-3.56,6.43-3.61,3.35-.07,3.38,4.46.36,6.12-2.7,1.48-6.5-1.17-7.27-1.75-2.65,4.16-5.4,8.32-7.84,11.63,0,.16,0,.25,0,.25l-.16,0c-.49.66-1,1.29-1.43,1.88-3.14,4-6.14,7.69-8.78,10.94-2.47,3.06-4.63,5.72-6.41,8,2.51-1.38,6.16-2.94,9.18-2.36,5.13,1,3.7,7.89-1.44,9.44-3.93,1.19-8.11-2.5-9.85-4.3l-.85,1.17c-1.05,1.5-4.25,5.29-7.81,9.4,3.48-2.1,9.68-5.21,14.66-4.27,7.34,1.4,5.3,11.3-2.05,13.52-6.17,1.86-12.77-4.68-14.73-6.82-5,5.72-10,11.33-10.38,11.76l-.66-.59c.18-.19,17.59-19.69,20.26-23.5C412.12,414.54,412.44,414.1,412.78,413.64Z",
    style: {
      fill: "#E94560"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-32"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 234.19,
    y1: 45.23,
    x2: 216.39,
    y2: 57.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.67,
    y1: 43.52,
    x2: 235.48,
    y2: 44.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.97,
    y1: 31.83,
    x2: 205.96,
    y2: 31.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.87,
    y1: 35.39,
    x2: 212.52,
    y2: 32.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.12,
    y1: 19.66,
    x2: 232.4,
    y2: 11.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.31,
    y1: 22.91,
    x2: 241.52,
    y2: 21.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.98,
    y1: 23.03,
    x2: 272.93,
    y2: 13.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 262.27,
    y1: 24.78,
    x2: 263.13,
    y2: 23.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.73,
    y1: 35.87,
    x2: 301.9,
    y2: 33.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.13,
    y1: 37.72,
    x2: 281.54,
    y2: 36.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.49,
    y1: 53.67,
    x2: 287.74,
    y2: 62.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.78,
    y1: 41.58,
    x2: 277.89,
    y2: 52.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.43,
    y: 41.09,
    width: 4.61,
    height: 13.28,
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.42 53.28 259.42 51.38 248.04 51.38 248.04 53.28 242.62 53.28 242.62 60.87 264.84 60.87 264.84 53.28 259.42 53.28",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.73 16.43 259.12 27.34 271.17 29.1 262.45 37.59 264.51 49.59 253.73 43.93 242.95 49.59 245.01 37.59 236.29 29.1 248.34 27.34 253.73 16.43",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "238.64 30.23 253.73 34.16 267.01 30.84",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 254.03,
    y1: 21.18,
    x2: 254.03,
    y2: 30.84,
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "244.68 47.74 253.43 36.27 253.43 41.1",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.51,
    y1: 49.6,
    x2: 255.54,
    y2: 36.27,
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.52,183.92s14.06,5.85,28.09,6.52,39.22-6.52,39.22-6.52l-16.72-21.55H233.35Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.11,292.24c-.51-1.54-4.88-13.09-4.88-13.09s-2.56-19.26-2.56-28.25-3.09-14.37-3.09-14.37L274,172.21l-2.33-8.14h-5.13l-14.26.13L238,164.07h-1.79l-5.87,11.16L227,236.53s-3.08,5.39-3.08,14.37-2.57,28.25-2.57,28.25-4.36,11.55-4.88,13.09-4.36,5.14-4.36,6.42a2.77,2.77,0,0,0,1,2.06H227s.77-.26,1.29-2.83a34.23,34.23,0,0,0,.51-6.67c0-1.54,1.54-14.38,1.54-14.38l19.77-82.33h4.37l19.77,82.33s1.54,12.84,1.54,14.38a34.23,34.23,0,0,0,.51,6.67c.51,2.57,1.28,2.83,1.28,2.83h13.87a2.77,2.77,0,0,0,1-2.06C292.48,297.38,288.63,293.78,288.11,292.24Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.23,279.15s-2.56-19.26-2.56-28.25-3.09-14.37-3.09-14.37L274,172.21l-2.33-8.14h-5.13l-14.26.13L238,164.07h-1.79l-5.87,11.16L227,236.53s-3.08,5.39-3.08,14.37-2.57,28.25-2.57,28.25l-.09.26H230c.17-1.53.3-2.57.3-2.57l19.77-82.33h4.37l19.77,82.33s.12,1,.3,2.57h8.78Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.71,282.19l-5,11.85h-9.37c-1.31,1.67-3.21,3.72-3.21,4.62a2.77,2.77,0,0,0,1,2.06H227s.77-.26,1.29-2.83a34.23,34.23,0,0,0,.51-6.67C228.8,290.35,229.29,285.91,229.71,282.19Z",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.87,282.19l5,11.85h9.36c1.31,1.67,3.22,3.72,3.22,4.62a2.77,2.77,0,0,1-1,2.06H277.58s-.77-.26-1.28-2.83a34.23,34.23,0,0,1-.51-6.67C275.79,290.35,275.3,285.91,274.87,282.19Z",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.86,80.63s-4.56-2.39-8,2.4-1.09,9.12-1.09,10.43-5.21,5.65-3.69,7.61,3.91,3,3.69,3.91-6.3-.44-5.86,1.74.86,5.65,8.69,11.52,19.13,1.08,22.17-2.18,5.65-6.52,5.22-8.47-3.48-1.31-3.48-2.18,3.26-3.91,3.26-5.65-3.48-3.91-3.7-5,1.74-2.61,1.74-4.34-4.35-3.92-4.35-5.44,3.27-4.13-1.73-7.61S252,76.5,250.86,80.63Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.49,107.66l-1.74,8.84s-4.06-1.74-5.22-2.18S238,164.07,238,164.07h32.31l-1.74-49.46-7.24,1.89-2.18-9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.8,131l1.28-14.94-1.71.45-2.18-9-9.7.15-1.74,8.84-1.43-.61,1.57,15.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.4,109.45s5.81,5.57,7,5.57,4.84-5.08,4.84-5.08l-.48-1.7L248.4,108Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.65,74l10-10.41-2.86-7.8s2.84-5.27,3.09-5.87,1.29-2.41,1.29-2.41a1.61,1.61,0,0,1,1.71,1.62,34.13,34.13,0,0,1,.1,5.8c-.23.89,2.28,5.8,1.28,8S233.05,79.1,233.05,79.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.88,50.69s-3.17,4.58-3.14,5a8.24,8.24,0,0,0,.22,1.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "242.26 47.98 238.04 54.22 238.03 56.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.43,115.05s-1,26.71-2.46,37-3.19,16.23-6.67,21.45-14.78,10.43-14.78,10.43,8.11-28,9.71-35.64,1.59-23.81,1.59-23.81a66.28,66.28,0,0,1-13-13.62c-5.79-8.26-10.49-16.79-10.24-18s23-23.14,23-23.14l4.67,6.3L224.59,95.32s11.86,13.79,12.72,14.51S241.52,111,245.43,115.05Z",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.74,114.37l0,.1s-4.78,8.84-4.78,17.1c0,4.75,1.44,20,2.66,23,.13-.83.26-1.67.39-2.56,1.44-10.28,2.46-37,2.46-37C245.2,114.81,245,114.58,244.74,114.37Z",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.52,73.75,268.8,64l2.31-8s-3.18-5.07-3.47-5.65-1.45-2.32-1.45-2.32a1.61,1.61,0,0,0-1.6,1.74,33.4,33.4,0,0,0,.29,5.8c.29.87-1.88,5.94-.72,8.11s12.31,15.36,12.31,15.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.74,51.44s3.48,4.34,3.48,4.78a7.66,7.66,0,0,1-.15,1.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "265.17 48.68 269.81 54.63 269.95 56.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.92,115.05s1,26.71,2.46,37,3.19,16.23,6.67,21.45,14.78,10.43,14.78,10.43-8.12-28-9.71-35.64-1.6-23.81-1.6-23.81a66,66,0,0,0,13-13.62c5.8-8.26,12.9-17.93,12.47-19.09s-26-21.35-26-21.35l-3.63,7,12.53,19s-12,12.75-12.9,13.47S268.83,111,264.92,115.05Z",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,115.19c-1.21,4.86-5.18,9.28-5.18,9.28s2.45-5.64,1.84-10.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.81,114a71.42,71.42,0,0,0,6.71,10.5s-3.06-11.1-3.06-12.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.6,114.37l0,.1s4.78,8.84,4.78,17.1c0,4.75-1.43,20-2.66,23-.13-.83-.25-1.67-.38-2.56-1.45-10.28-2.46-37-2.46-37C265.15,114.81,265.38,114.58,265.6,114.37Z",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.28,98.82s-2.89-4.2-3.33-.58,3,6.23,3,6.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.85,98s2.46-2.46,3.18.43-3,5.51-3,5.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.73,84.55s-.65,3.69-3.26,4.56A6.83,6.83,0,0,0,245,91.28s-.43,12.61.44,13.91S252,112,254.85,112s9.63-5.08,9.85-6.38-.14-13.48-.36-14.35-3-2.17-5.44-2.17-4.34-2.61-4.78-3.48S251.73,84.55,251.73,84.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.61,94.91a4,4,0,0,0,2,.87,2,2,0,0,0,1.55-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.3,90.76a2.09,2.09,0,0,1,3.26-1.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.4,89.81s2.32-1.79,4.11,1.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.56,99s5,3,8.26-1.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.66,91.71c0,.6-.34,1.09-.76,1.09s-.76-.49-.76-1.09.34-1.08.76-1.08S251.66,91.11,251.66,91.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.7,91.81c0,.6-.34,1.09-.76,1.09s-.76-.49-.76-1.09.34-1.09.76-1.09S259.7,91.21,259.7,91.81Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stairs--inject-32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.27,
    y: 298.92,
    width: 115.63,
    height: 66.07,
    style: {
      fill: "#dbdbdb",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.45,
    y: 363.26,
    width: 251.25,
    height: 66.07,
    style: {
      fill: "#adadad",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.19,
    y: 408.32,
    width: 399.78,
    height: 66.07,
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "251.12 306.22 256.51 317.14 268.56 318.89 259.84 327.39 261.9 339.39 251.12 333.73 240.34 339.39 242.4 327.39 233.69 318.89 245.73 317.14 251.12 306.22",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.67 366.06 166.06 376.97 178.11 378.72 169.39 387.22 171.45 399.22 160.67 393.56 149.89 399.22 151.95 387.22 143.23 378.72 155.28 376.97 160.67 366.06",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.34 366.06 348.73 376.97 360.77 378.72 352.06 387.22 354.11 399.22 343.34 393.56 332.56 399.22 334.62 387.22 325.9 378.72 337.95 376.97 343.34 366.06",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-32"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 21.15,
    y1: 474.4,
    x2: 482.85,
    y2: 474.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievementBro);
export default __webpack_public_path__ + "static/media/Achievement-bro.91c9327f5228894bafe3b5580721b0fe.svg";
export { ForwardRef as ReactComponent };